<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TMb0eB/tc-custom/9780547669229.jpg?1703218067524" alt="This image is the cover for the book Nazis Next Door"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nazis Next Door
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>Newsweek </i>Best Book of the Year: “Captivating . . . rooted in first-rate research” (<i>The </i><i>New York Times Book Review</i>).</b><br/>  <br/> In this <i>New York Times</i> bestseller, once-secret government records and interviews tell the full story of the thousands of Nazis—from concentration camp guards to high-level officers in the Third Reich—who came to the United States after World War II and quietly settled into new lives.<br/>  <br/> Many gained entry on their own as self-styled war “refugees.” But some had help from the US government. The CIA, the FBI, and the military all put Hitler’s minions to work as spies, intelligence assets, and leading scientists and engineers, whitewashing their histories. Only years after their arrival did private sleuths and government prosecutors begin trying to identify the hidden Nazis. Now, relying on a trove of newly disclosed documents and scores of interviews, Pulitzer Prize–winning investigative reporter Eric Lichtblau reveals this little-known and “disturbing” chapter of postwar history (<i>Salon</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eric Lichtblau
      </h2>
      
      <p class="authorDescription body article">Eric Lichtblau is a Pulitzer Prize–winning investigative reporter in the Washington bureau of the <I>New York Times</I> and has written about legal, political, and national security issues in the capital since 1999. He was the co-recipient of the Pulitzer Prize in 2006 for his stories in the <I>New York Times</I> disclosing the existence of a secret wiretapping program approved by President George W. Bush after the 9/11 attacks. He was a reporter for the <I>Los Angeles Times</I> for fifteen years before joining the <I>New York Times</I> in 2002. A graduate of Cornell University, he is the author of <I>Bush</I><I>&rsquo;</I><I>s Law: The Remaking of American Justice</I>, which one reviewer called &ldquo;<I>All the President&rsquo;s Men</I> for an Age of Terror.&rdquo; In the course of research for <I>The Nazis Next Door</I>, he was a visiting fellow at the United States Holocaust Museum in Washington, DC. He lives outside Washington with his wife and children. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b620628